import {
  QUIZ_RESULT__GET_RESULT,
  QUIZ_RESULT__GET_RESULT_SUCCESS,
  QUIZ_RESULT__GET_RESULT_FAIL,
  RESET_RESULT,
  QUIZ_RESULT__GET_RESULT_ATTEMPTS,
  QUIZ_RESULT__GET_RESULT_ATTEMPTS_SUCCESS,
  QUIZ_RESULT__GET_RESULT_ATTEMPTS_FAIL,
} from '../constants';
import { buildQuery } from '../helpers';

export function getResult(id, params = {}) {
  return {
    types: [
      QUIZ_RESULT__GET_RESULT,
      QUIZ_RESULT__GET_RESULT_SUCCESS,
      QUIZ_RESULT__GET_RESULT_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/quizzes/${id}/quiz-result?${buildQuery(params)}`, {
        method: 'GET',
      }),
  };
}

export function getResultAttempts(id, params = {}) {
  return {
    types: [
      QUIZ_RESULT__GET_RESULT_ATTEMPTS,
      QUIZ_RESULT__GET_RESULT_ATTEMPTS_SUCCESS,
      QUIZ_RESULT__GET_RESULT_ATTEMPTS_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/quizzes/${id}/quiz-result/attempts?${buildQuery(params)}`, {
        method: 'GET',
      }),
  };
}

export function resetResult() {
  return {
    type: RESET_RESULT,
  };
}
